module.exports = {"id":"190558","name":"Ike Opara","rating":"75","photo":"./data/images/photos/3/190558.png","club":{"name":"Sporting KC","logo":"./data/images/clubs/SportingKC.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IkeOpara0.json
// module id = 1792
// module chunks = 0